import request from './request';

const getHistoryDataAsync = (searchDate) => request.get('vns/History', {searchDate});

const getStatisticDataAsync = (dayRange) => request.get('vns/Statistics/' + (dayRange ?? 1), {});

export default {
    getHistoryDataAsync,
    getStatisticDataAsync
};